module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "width": "550",
      "close-on-content-click": false,
      "activator": _vm.selectedElement,
      "nudge-bottom": 4,
      "offset-y": "",
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "scrollable": "",
      "content-class": "elevation-0"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('v-card', {
    staticClass: "rounded-xl"
  }, [(_vm.selectedEvent) ? [_c('v-img', {
    attrs: {
      "src": _vm.selectedEventImage,
      "height": _vm.$vuetify.breakpoint.smAndDown ? '0px' : '220px'
    }
  }, [_c('v-card-title', {
    staticClass: "pt-3 px-5 ma-0 pa-0 justify-end"
  }, [_c('span', [(_vm.allowEdit(_vm.selectedEvent)) ? _c('v-btn', {
    staticClass: "hidden-xs-only",
    staticStyle: {
      "background-color": "rgb(255, 255, 255, 0.7)"
    },
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.downloadAnmeldungen()
      }
    }
  }, [_c('v-icon', {
    staticClass: "black--text"
  }, [_vm._v("print")])], 1) : _vm._e(), _vm._v(" "), _c('v-btn', {
    staticStyle: {
      "background-color": "rgb(255, 255, 255, 0.7)"
    },
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.shareVeranstaltung(_vm.selectedEvent)
      }
    }
  }, [_c('v-icon', {
    staticClass: "black--text"
  }, [_vm._v("ios_share")])], 1), _vm._v(" "), (_vm.allowEdit(_vm.selectedEvent)) ? _c('v-btn', {
    staticStyle: {
      "background-color": "rgb(255, 255, 255, 0.7)"
    },
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.showVeranstaltungEdit = true
      }
    }
  }, [_c('v-icon', {
    staticClass: "black--text"
  }, [_vm._v("edit")])], 1) : _vm._e(), _vm._v(" "), _c('v-btn', {
    staticClass: "hidden-xs-only",
    staticStyle: {
      "background-color": "rgb(255, 255, 255, 0.7)"
    },
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_c('v-icon', {
    staticClass: "black--text"
  }, [_vm._v("close")])], 1)], 1)])], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "pl-6 pb-0 pt-4 ma-0 pa-0",
    staticStyle: {
      "background-color": "rgb(255, 255, 255, 0.3)"
    }
  }, [_c('span', {
    staticClass: "body-2"
  }, [_vm._v(_vm._s(_vm.$filters.date(_vm.selectedEvent.vonDatum, "DD.MM.YYYY")) + ", " + _vm._s(_vm.selectedEvent.vonZeit) + " Uhr -\n          " + _vm._s(_vm.selectedEvent.bisZeit) + " Uhr")])]), _vm._v(" "), _c('v-card-title', {
    staticClass: "pt-0"
  }, [_c('span', {
    staticClass: "font-weight-bold black--text",
    staticStyle: {
      "word-break": "break-word"
    }
  }, [_vm._v(_vm._s(_vm.selectedEvent.name))])]), _vm._v(" "), _c('v-card-text', {
    staticClass: "ma-0 pa-0"
  }, [_c('v-row', {
    staticClass: "pa-0 ma-0",
    attrs: {
      "no-gutters": ""
    }
  }, [(_vm.selectedEvent.bemerkung) ? _c('v-col', {
    staticClass: "pa-0 ma-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-list-item', {
    attrs: {
      "dense": ""
    }
  }, [_c('v-list-item-avatar', {
    staticClass: "pa-0 ma-0"
  }, [_c('v-icon', [_vm._v("info")])], 1), _vm._v(" "), _c('v-list-item-content', [_vm._v("\n                " + _vm._s(_vm.selectedEvent.bemerkung) + "\n              ")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.selectedEvent.ort) ? _c('v-col', {
    staticClass: "pa-0 ma-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-list-item', {
    attrs: {
      "dense": ""
    }
  }, [_c('v-list-item-avatar', {
    staticClass: "pa-0 ma-0"
  }, [_c('v-icon', [_vm._v("location_on")])], 1), _vm._v(" "), _c('v-list-item-content', [_vm._v("\n                " + _vm._s(_vm.selectedEvent.ort) + "\n              ")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.selectedEvent.anmeldungBis) ? _c('v-col', {
    staticClass: "pa-0 ma-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-list-item', {
    attrs: {
      "dense": ""
    }
  }, [_c('v-list-item-avatar', {
    staticClass: "pa-0 ma-0"
  }, [_c('v-icon', [_vm._v("event")])], 1), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-subtitle', {
    staticClass: "font-weight-regular caption"
  }, [_vm._v("Anmeldung bis")]), _vm._v("\n                " + _vm._s(_vm.$filters.date(_vm.selectedEvent.anmeldungBis, "DD.MM.YYYY")) + "\n              ")], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.selectedEvent.kleiderordnung) ? _c('v-col', {
    staticClass: "pa-0 ma-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-list-item', {
    attrs: {
      "dense": ""
    }
  }, [_c('v-list-item-avatar', {
    staticClass: "pa-0 ma-0"
  }, [_c('v-icon', [_vm._v("face")])], 1), _vm._v(" "), _c('v-list-item-content', [_vm._v("\n                " + _vm._s(_vm.selectedEvent.kleiderordnung) + "\n              ")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.selectedEvent.kategorie) ? _c('v-col', {
    staticClass: "pa-0 ma-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-list-item', {
    attrs: {
      "dense": ""
    }
  }, [_c('v-list-item-avatar', {
    staticClass: "pa-0 ma-0"
  }, [_c('v-icon', [_vm._v("label")])], 1), _vm._v(" "), _c('v-list-item-content', [_vm._v("\n                " + _vm._s(_vm.selectedEvent.kategorie) + "\n              ")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.selectedEvent.preis) ? _c('v-col', {
    staticClass: "pa-0 ma-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-list-item', {
    attrs: {
      "dense": ""
    }
  }, [_c('v-list-item-avatar', {
    staticClass: "pa-0 ma-0"
  }, [_c('v-icon', [_vm._v("euro")])], 1), _vm._v(" "), _c('v-list-item-content', [_vm._v("\n                " + _vm._s(_vm._f("money")(_vm.selectedEvent.preis)) + "\n              ")])], 1)], 1) : _vm._e()], 1), _vm._v(" "), (_vm.selectedEvent.anmeldungen) ? [_c('v-expansion-panels', {
    staticStyle: {
      "width": "99%"
    },
    attrs: {
      "flat": ""
    }
  }, [_c('v-expansion-panel', {
    staticClass: "pa-0 ma-0"
  }, [_c('v-expansion-panel-header', {
    staticClass: "pa-0 ma-0"
  }, [_c('v-list-item', {
    attrs: {
      "dense": ""
    }
  }, [_c('v-list-item-avatar', {
    staticClass: "pa-n2 ma-0"
  }, [_c('v-icon', [_vm._v("group")])], 1), _vm._v(" "), _c('v-list-item-content', {
    staticClass: "mr-n4"
  }, [(_vm.selectedEvent.anmeldungen.length + _vm.selectedEvent.weitereAnmeldungen.length === 1) ? _c('span', [_vm._v("1 Anmeldung")]) : _c('span', [_vm._v(_vm._s(_vm.selectedEvent.anmeldungen.length + _vm.selectedEvent.weitereAnmeldungen.length) + "\n                      Anmeldungen")])])], 1)], 1), _vm._v(" "), _c('v-expansion-panel-content', [_c('v-simple-table', {
    attrs: {
      "fixed-header": "",
      "max-height": "calc(100vh - 415px)",
      "dense": ""
    }
  }, [_c('tbody', [_vm._l((_vm.anmeldungen), function(item) {
    return _c('tr', {
      key: item.id
    }, [_c('td', [_vm._v(_vm._s(item.bbr))])])
  }), _vm._v(" "), (_vm.selectedEvent.weitereAnmeldungen.length > 0) ? _c('tr', {
    on: {
      "click": function($event) {
        _vm.showAlleAnmeldungen = !_vm.showAlleAnmeldungen
      }
    }
  }, [(!_vm.showAlleAnmeldungen) ? _c('td', [_vm._v("\n                        + " + _vm._s(_vm.selectedEvent.weitereAnmeldungen.length) + " Begleitungen\n                        "), _c('v-icon', [_vm._v("keyboard_arrow_down")])], 1) : _vm._e(), _vm._v(" "), (_vm.showAlleAnmeldungen) ? _c('td', [_c('v-icon', [_vm._v("keyboard_arrow_up")]), _vm._v(" Begleitungen ausblenden")], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), _vm._l((_vm.selectedEvent.weitereAnmeldungen), function(item) {
    return (_vm.showAlleAnmeldungen) ? _c('tr', {
      key: item.id
    }, [_c('td', [_vm._v(_vm._s(item.name))])]) : _vm._e()
  })], 2)])], 1)], 1)], 1)] : _vm._e()], 2), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', {
    staticClass: "mb-6 mb-md-0"
  }, [_c('v-btn', {
    attrs: {
      "rounded": "",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_vm._v("Schließen")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.selectedEvent.anmeldungBis >= _vm.heute || !_vm.selectedEvent.anmeldungBis) ? _c('div', [(_vm.selectedEvent.anmeldungen) ? [(
    _vm.selectedEvent.anmeldungen.includes(_vm.currentBbr) &&
    !_vm.selectedEvent.pflichtanmeldungen.includes(_vm.currentBbrStatus)
  ) ? _c('v-btn', {
    attrs: {
      "rounded": "",
      "text": "",
      "color": "accent"
    },
    on: {
      "click": function($event) {
        _vm.showZuVeranstaltungAbmelden = true
      }
    }
  }, [_vm._v("Abmelden")]) : _vm._e(), _vm._v(" "), (_vm.selectedEvent.anmeldungen.includes(_vm.currentBbr)) ? _c('v-btn', {
    attrs: {
      "icon": "",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.showWeiterenAnmelden = true
      }
    }
  }, [_c('v-icon', [_vm._v("exposure_plus_1")])], 1) : _vm._e(), _vm._v(" "), (!_vm.selectedEvent.anmeldungen.includes(_vm.currentBbr)) ? _c('v-btn', {
    attrs: {
      "rounded": "",
      "text": "",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.zuVeranstaltungAnmelden()
      }
    }
  }, [_vm._v("Anmelden")]) : _vm._e()] : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.selectedEvent.pflichtanmeldungen) ? _c('div', [(
    _vm.selectedEvent.anmeldungen.includes(_vm.currentBbr) &&
    _vm.selectedEvent.pflichtanmeldungen.includes(_vm.currentBbrStatus)
  ) ? _c('span', [_vm._v("\n              Du bist Pflichtangemeldet und kannst dich nicht über das System abmelden. Bitte melde dich diekt beim\n              Consenior ab. Dieser trägt das dann im System ein.\n            ")]) : _vm._e()]) : _vm._e()], 2) : _c('v-card-text', [_vm._v("\n          Eine An- oder Abmeldung zu dieser Veranstaltung ist nicht mehr möglich. Bitte wende Dich direkt an den\n          Consenior, falls du dich nachträglich an- bzw abmelden willst.\n        ")])], 1)] : _vm._e()], 2), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "500",
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "persistent": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.showWeiterenAnmelden),
      callback: function($$v) {
        _vm.showWeiterenAnmelden = $$v
      },
      expression: "showWeiterenAnmelden"
    }
  }, [_c('v-card', {
    staticClass: "rounded-lg"
  }, [_c('v-card-title', [_vm._v(" Weitere Personen anmelden ")]), _vm._v(" "), _c('v-card-subtitle', {
    staticClass: "pt-1"
  }, [_vm._v("\n        Hier kannst du weitere Personen, Freunde und Bekannte, die sich nicht selber anmelden können, anmelden.\n      ")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', {
    staticClass: "py-2"
  }, [_c('v-list', {
    attrs: {
      "dense": ""
    }
  }, _vm._l((_vm.selectedEvent.weitereAnmeldungen), function(item) {
    return (item.angemeldetVon === _vm.currentBbr) ? _c('v-list-item', {
      key: item.id
    }, [_c('v-list-item-content', [_c('v-list-item-title', [_vm._v(_vm._s(item.name))])], 1), _vm._v(" "), _c('v-list-item-action', [_c('v-icon', {
      on: {
        "click": function($event) {
          return _vm.weiterenAbmelden(item)
        }
      }
    }, [_vm._v("close")])], 1)], 1) : _vm._e()
  }), 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', {
    staticClass: "py-2"
  }, [_c('v-text-field', {
    attrs: {
      "outlined": "",
      "dense": "",
      "hide-details": "",
      "placeholder": "Bitte Vorname und Nachname eintragen.",
      "append-outer-icon": "add"
    },
    on: {
      "click:append-outer": function($event) {
        return _vm.weiterenAnmelden()
      }
    },
    model: {
      value: (_vm.name),
      callback: function($$v) {
        _vm.name = $$v
      },
      expression: "name"
    }
  })], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', {
    staticClass: "mb-6 mb-md-0"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.showWeiterenAnmelden = false
      }
    }
  }, [_vm._v(" Schließen ")])], 1)], 1)], 1), _vm._v(" "), _c('dialogDelete', {
    attrs: {
      "visible": _vm.showZuVeranstaltungAbmelden,
      "title": "Abmelden",
      "message": 'Willst du dich wirklich von der Veranstaltung ' + _vm.selectedEvent.name + ' abmelden?',
      "abbrechen": "Angemeldet bleiben",
      "weiter": "Abmelden"
    },
    on: {
      "update:visible": function($event) {
        _vm.showZuVeranstaltungAbmelden = $event
      },
      "closeTrue": function($event) {
        return _vm.zuVeranstaltungAbmelden()
      },
      "closeFalse": function($event) {
        _vm.showZuVeranstaltungAbmelden = false
      }
    }
  }), _vm._v(" "), _c('dialogVeranstaltungEdit', {
    attrs: {
      "visible": _vm.showVeranstaltungEdit,
      "veranstaltung": _vm.selectedEvent
    },
    on: {
      "update:visible": function($event) {
        _vm.showVeranstaltungEdit = $event
      },
      "close": function($event) {
        _vm.showVeranstaltungEdit = false
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-316ede81"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/module/submodule/dialogVeranstaltung.vue
// module id = 754
// module chunks = 15